import { ICategory } from "@eventr/common";
import { ColoursObj, Icon, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "i18n/i18next";
import { useMemo } from "react";
import { getCategoryColours } from "utils";
import useDerivedScreenType from "v2/hooks/useDerivedScreenType";
import { useFormatValue } from "../../hooks/useFormatValue";
import { isSameDay } from "../card-utils";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { DisplayLabel } from "../subComponents/displayLabel";

interface IHireCarHeaderProps {
  car_alias?: string;
  label?: string;
  labelTime?: string;
  pick_up?: string;
  drop_off?: string;
  category?: ICategory | undefined;
  date?: string;
  visibility?: string;
}

export const HireCarHeader = ({
  category,
  car_alias,
  label,
  labelTime,
  pick_up,
  drop_off,
  date,
  visibility,
}: IHireCarHeaderProps) => {
  const { past } = useObjectContext();
  const screenType = useDerivedScreenType();
  const { formatValue } = useFormatValue();
  const iconColour = getCategoryColours(past, category);

  const labelOverride = useMemo(() => {
    if (date) {
      if (pick_up && isSameDay(date, pick_up)) {
        return `${i18n.t("cards.pick-up")} ${formatValue(pick_up, "time")}`;
      }
      if (drop_off && isSameDay(date, drop_off)) {
        return `${i18n.t("cards.drop-off")} ${formatValue(drop_off, "time")}`;
      }
    }
    return undefined;
  }, [date, drop_off, formatValue, pick_up]);

  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <Icon name={(category?.icon as TEventrIcons) ?? "Hire_Car"} iconColour={iconColour} />
        <CardText variant="bodyBold">{car_alias}</CardText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" ? (
          <Icon
            height="16px"
            width="16px"
            name="Private"
            iconColour={past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary}
          />
        ) : (
          visibility?.toLowerCase() === "public" && (
            <Icon
              height="16px"
              width="16px"
              name="Public"
              iconColour={past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary}
            />
          )
        )}
        {screenType === "upNext" || screenType === "team" ? (
          <DisplayLabel
            label={label}
            labelTime={labelTime}
            overrideLabel={screenType === "team" ? labelOverride : undefined}
          />
        ) : (
          <CardText variant="bodyBold">{formatValue(pick_up ?? "", "date")}</CardText>
        )}
      </Stack>
    </Stack>
  );
};
